<div class="confirm-dialog">
    <div class="confirm-icon" [class.confirm-icon--danger]="data.danger !== false" aria-hidden="true">
        <i class="fas" [ngClass]="data.danger === false ? 'fa-circle-question' : 'fa-trash'"></i>
    </div>
    <h2>{{ data.title }}</h2>
    <p>{{ data.message }}</p>
    <div class="confirm-actions">
        <button mat-stroked-button class="dialog-button" (click)="cancel()">{{ data.cancelLabel || 'Cancelar' }}</button>
        <button mat-raised-button class="dialog-button confirm-button"
            [class.confirm-button--danger]="data.danger !== false"
            (click)="confirm()">{{ data.confirmLabel || 'Aceptar' }}</button>
    </div>
</div>
